import { render, staticRenderFns } from "./ProfilePictures.vue?vue&type=template&id=b65ce088"
import script from "./ProfilePictures.vue?vue&type=script&lang=js"
export * from "./ProfilePictures.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictures.vue?vue&type=style&index=0&id=b65ce088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports